import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=941ade2e&scoped=true&"
import script from "./bottomNav.vue?vue&type=script&lang=js&"
export * from "./bottomNav.vue?vue&type=script&lang=js&"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=941ade2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941ade2e",
  null
  
)

export default component.exports